/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: "",
            component: () => import("./layouts/main/Main.vue"),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: "/",
                    redirect: "/tela-inicial"
                },
                // {
                //     path: '/dashboard/analytics',
                //     name: 'dashboard-analytics',
                //     component: () => import('./views/DashboardAnalytics.vue'),
                //     meta: {
                //         rule: 'editor',
                //     }
                // },
                // {
                //     path: '/dashboard/ecommerce',
                //     name: 'dashboard-ecommerce',
                //     component: () => import('./views/DashboardECommerce.vue'),
                //     meta: {
                //         rule: 'admin'
                //     }
                // },
                {
                    path: "/banners-home",
                    name: "BannersHome",
                    component: () => import("./views/econ/banners-home.vue"),
                    meta: {
                        breadcrumb: [{ title: "Banners Home", active: true }],
                        rule: "admin"
                    }
                },
                {
                    path: "/banners-oportunidades",
                    name: "BannersOportunidades",
                    component: () =>
                        import("./views/econ/banners-oportunidades.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Banners Oportunidades", active: true }
                        ],
                        rule: "admin"
                    }
                },
                // {
                //     path: "/banner",
                //     name: "Banner",
                //     component: () => import("./views/econ/banners-home.vue"),
                //     meta: {
                //         breadcrumb: [{ title: "Home", active: true }],
                //         rule: "admin"
                //     }
                // },
                {
                    path: "/tela-inicial",
                    name: "Homepage",
                    component: () => import("./views/econ/tela-inicial.vue"),
                    meta: {
                        breadcrumb: [{ title: "Home", active: true }],
                        rule: "admin"
                    }
                },
                {
                    path: "/acessibilidade",
                    name: "Acessibilidade",
                    component: () => import("./views/econ/acessibilidade.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Sobre Econ" },
                            { title: "Acessibilidade", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/consent-log",
                    name: "Log de consentimento",
                    component: () => import("./views/econ/consent-log.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Log de Consentimento", active: true }
                        ],
                        rule: "editor"
                    }
                },
                {
                    path: "/certificados-premios",
                    name: "CertificadosPremios",
                    component: () =>
                        import("./views/econ/certificados-premios.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Sobre Econ" },
                            { title: "Certificados e Prêmios", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/quem-somos",
                    name: "QuemSomos",
                    component: () => import("./views/econ/quem-somos.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Sobre Econ" },
                            { title: "Quem Somos", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/contatos",
                    name: "ContatosRecebidos",
                    component: () => import("./views/econ/contatos.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Contatos", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/empreendimentos/lista",
                    name: "ListaEmpreendimentos",
                    component: () =>
                        import("./views/econ/lista-empreendimentos.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Empreendimentos" },
                            { title: "Lista de Empreendimentos", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/empreendimentos/novo",
                    name: "NovoEmpreendimento",
                    component: () =>
                        import("./views/econ/cadastro-empreendimentos.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            {
                                title: "Empreendimentos",
                                url: "/empreendimentos/lista"
                            },
                            { title: "Novo Empreendimento", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/empreendimentos/slug/:slug",
                    name: "EditarEmpreendimento",
                    component: () =>
                        import("./views/econ/cadastro-empreendimentos.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            {
                                title: "Empreendimentos",
                                url: "/empreendimentos/lista"
                            },
                            { title: "Novo Empreendimento", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/empreendimentos-batch",
                    name: "NovoEmpreendimento",
                    component: () => import("./views/econ/batch-update.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            {
                                title: "Empreendimentos",
                                url: "/empreendimentos/lista"
                            },
                            { title: "Preço em Lote", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/fab/",
                    name: "Fab",
                    component: () => import("./views/econ/fab.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Fab", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/footer/",
                    name: "Footer",
                    component: () => import("./views/econ/footer.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Rodapé", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/dados-contato/",
                    name: "DadosContato",
                    component: () => import("./views/econ/dados-contato.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Dados para Contato", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/menu/",
                    name: "Menu",
                    component: () => import("./views/econ/menu.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Menu", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/regulamentos/",
                    name: "Regulamentos",
                    component: () => import("./views/econ/regulamentos.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Regulamentos", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/venda-seu-terreno/",
                    name: "VendaSeuTerreno",
                    component: () =>
                        import("./views/econ/venda-seu-terreno.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Venda seu Terreno", active: true }
                        ],
                        rule: "admin"
                    }
                },
                {
                    path: "/cadastro-vagas/",
                    name: "CadastroVagas",
                    component: () => import("./views/econ/cadastro-vagas.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Cadastro de Vagas", active: true }
                        ],
                        rule: "publisher"
                    }
                },
                {
                    path: "/candidatos-vagas/",
                    name: "CandidatosVagas",
                    component: () =>
                        import("./views/econ/candidatos-vagas.vue"),
                    meta: {
                        breadcrumb: [
                            { title: "Home", url: "/" },
                            { title: "Candidatos", active: true }
                        ],
                        rule: "publisher"
                    }
                }
            ]
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: "",
            component: () => import("@/layouts/full-page/FullPage.vue"),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: "/login",
                    name: "page-login",
                    component: () => import("@/views/pages/login/Login.vue"),
                    meta: {
                        rule: "admin"
                    }
                },
                {
                    path: "/pages/error-404",
                    name: "page-error-404",
                    component: () => import("@/views/pages/Error404.vue"),
                    meta: {
                        rule: "admin"
                    }
                }
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: "*",
            redirect: "/pages/error-404"
        }
    ]
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

router.beforeEach((to, from, next) => {
    const apiUrl = Vue.prototype.$API_URL;
    if (to.path === "/login") {
        return next();
    }
    if (
        localStorage.getItem("token") &&
        localStorage.getItem("token").length > 0
    ) {
        fetch(apiUrl + "/login/validate-token", {
            method: "POST",
            headers: new Headers({
                Accept: "application/json",
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({
                token: localStorage.getItem("token")
            })
        })
            .then(response => response.json())
            .then(json => {
                if (json.status == "success") {
                    next();
                } else {
                    router.push({ path: "/login", query: { to: to.path } });
                }
            });
    } else {
        router.push({ path: "/login", query: { to: to.path } });
    }
});

export default router;
